import React from 'react';

export const LockClosed = () => (
    <svg viewBox="0 0 16 16" aria-hidden="true">
        <path d="M8 1.5A2.5 2.5 0 0 0 5.5 4v2H4.5A1.5 1.5 0 0 0 3 7.5v6A1.5 1.5 0 0 0 4.5 15h7a1.5 1.5 0 0 0 1.5-1.5v-6A1.5 1.5 0 0 0 11.5 6H10.5V4A2.5 2.5 0 0 0 8 1.5zM6.5 4a1.5 1.5 0 0 1 3 0v2h-3V4z" />
    </svg>
);

export const LockOpen = () => (
    <svg viewBox="0 0 16 16" aria-hidden="true">
        <path d="M11.5 6H6.5V4a1.5 1.5 0 0 1 2.8-.75.5.5 0 0 0 .9-.45A2.5 2.5 0 0 0 5.5 4v2H4.5A1.5 1.5 0 0 0 3 7.5v6A1.5 1.5 0 0 0 4.5 15h7a1.5 1.5 0 0 0 1.5-1.5v-6A1.5 1.5 0 0 0 11.5 6z" />
    </svg>
);